import React, { useEffect, useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { customerVerifyDetail } from "../../../redux/actions/customerVerificationAction";
import back from "../../../assets/icons/back.svg";
import { Spinner } from "react-bootstrap";
import { AdminButton } from "../../../components/buttons/versionHistoryBtn";
import LoadingSpinnerTable from "../../../components/utilites/loader";
import useReactRouterBreadcrumbs from "use-react-router-breadcrumbs";
import ReportIssueModal from "../../../components/modals/reportIssueModal";
import CustomerVerifyDoctorView from "../../../components/customerVerification/customerVerfiDoctorView";
import CustomerVerifyPharmacyView from "../../../components/customerVerification/customerVerifyPharmacyView";
import { pdfChecker } from "../../../components/utilites/helper";

const CustomerVerificationView = () => {
  const { state } = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [customerViewData, setCustomerViewData] = useState([]);
  const [customerTypeData, setCustomerTypeData] = useState([]);
  const [customerDoctorData, setCustomerDoctordata] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showReportModal, setShowReportModal] = useState(false);

  useEffect(() => {
    fetchCustomerView();
  }, []);

  const fetchCustomerView = () => {
    console.log(state);
    dispatch(customerVerifyDetail(state, onSuccess, onError));
    setCustomerTypeData(state);
    setLoading(true);
  };
  const onSuccess = (data) => {
    console.log(data);
    setLoading(false);
    setCustomerViewData(data.data.data);
    setCustomerDoctordata(data.data.data.pharmacyDoctors);
    console.log(data.data.data.pharmacyDoctors.pharmacy_id, "fgd");
  };
  const onError = (err) => {
    setLoading(false);
    console.log(err);
  };

  const routes = [
    { path: "/", breadcrumb: "Admin" },
    {
      path: "/support/customer-verification",
      breadcrumb: " / customer verification",
    },
    {
      path: "/support/customer-verification/view/:id",
      breadcrumb: customerViewData?.code
        ? ` / ${customerViewData?.code} - view`
        : " / view",
    },
  ];
  const breadcrumbs = useReactRouterBreadcrumbs(routes, {
    disableDefaults: true,
  });

  const [userData, setUserData] = useState(null);
  const user_type = localStorage.getItem("userType");
  const is_subscribed = localStorage.getItem("is_subscribed");
  useEffect(() => {
    if (user_type === "super_user") {
      const permissionData = JSON.parse(localStorage.getItem("permissions"));
      const permissionValue = permissionData?.find(
        (item) => item?.module_name === "Support" && item
      );

      setUserData(permissionValue);
    }
  }, []);

  return (
    <>
      <div className="products-page text-nowrap">
        <div className="products-main-div">
          <div className="mx-3">
            {breadcrumbs.map(({ match, breadcrumb }) => (
              <NavLink
                key={match.pathname}
                to={match.pathname}
                className="header-route-page fw_400 cursor_pointer"
              >
                <span className="fs_18">{breadcrumb}</span>
              </NavLink>
            ))}
          </div>
          <div className="products-main-list my-2 py-1">
            <div className="search-container d-flex justify-content-between ">
              <div
                className="d-flex align-items-center p-2 ms-3 m-1 mb-2 cursor_pointer"
                onClick={() => navigate(-1)}
              >
                <img src={back} alt="back_btn" />
                <span className="px-2 dark_grey_color fs_16 fn_Nunito fw_600">
                  BACK
                </span>
              </div>
              <div className=" d-flex justify-content-between align-items-center m-1 mb-2">
                {(user_type == "super_user" && userData?.write) ||
                user_type == "vendor" ? (
                  <AdminButton
                    background="#7065E4"
                    color="white"
                    width="170px"
                    type="button"
                    onClick={() => {
                      setShowReportModal(true);
                    }}
                  >
                    <span className="mx-2">REPORT AN ISSUE</span>
                  </AdminButton>
                ) : (
                  ""
                )}
              </div>
            </div>
            <div style={{ position: "relative" }}>
              {loading == true ? (
                <div className="list-spinner-container">
                  <LoadingSpinnerTable />
                </div>
              ) : (
                <>
                  {customerTypeData?.user_type === "doctor" ? (
                    <>
                      <CustomerVerifyDoctorView
                        customerViewData={customerViewData}
                      />
                    </>
                  ) : (
                    <CustomerVerifyPharmacyView
                      customerViewData={customerViewData}
                    />
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      <ReportIssueModal
        typedata={state}
        customerViewData={customerViewData}
        show={showReportModal}
        handleClose={() => {
          setShowReportModal(false);
        }}
      />
    </>
  );
};

export default CustomerVerificationView;
